module.exports = __webpack_public_path__ + "img/pithapur.f8cd13e5.jpg";